import { render, staticRenderFns } from "./ProgressTracker.vue?vue&type=template&id=2bb7b9c2&scoped=true&"
import script from "./ProgressTracker.vue?vue&type=script&lang=ts&"
export * from "./ProgressTracker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7b9c2",
  null
  
)

export default component.exports